module.exports = __webpack_public_path__ + "img/59.f133966a.png";